import { render, staticRenderFns } from "./Plazos.vue?vue&type=template&id=bca0f6d6"
import script from "./Plazos.vue?vue&type=script&lang=js"
export * from "./Plazos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports